import AbstractObserver from './abstract';

export default class HeaderShowHideObserver extends AbstractObserver {
  constructor(element, config) {
    super(element, config);
    this.dataSettings = this.element.hasAttribute('data-ua-header-options')
      ? JSON.parse(this.element.getAttribute('data-ua-header-options'))
      : {};
    this.config = config;
  }

  init() {
    if (!this.defaultState && window.scrollY > this.offset) {
      return this;
    }

    this.defaultState = true;
    this.transitionDuration = parseFloat(getComputedStyle(this.element)['transition-duration'], 10) * 1000;

    this.offset =
      isFinite(this.dataSettings.fixMoment) && this.dataSettings.fixMoment > this.element.offsetHeight
        ? this.dataSettings.fixMoment
        : this.element.offsetHeight + 100;
    this.effect = this.dataSettings.fixEffect ? this.dataSettings.fixEffect : 'show-hide';

    return this;
  }

  destroy() {
    if (!this.defaultState && window.scrollY > this.offset) {
      return this;
    }

    this.element.classList.remove('navbar-untransitioned');
    this._removeCap();

    return this;
  }

  check() {
    if (window.scrollY > this.element.offsetHeight && !this.capInserted) {
      this._insertCap();
    } else if (window.scrollY <= this.element.offsetHeight && this.capInserted) {
      this._removeCap();
    }

    if (window.scrollY > this.offset && this.defaultState) {
      this.changeState();
    } else if (window.scrollY <= this.offset && !this.defaultState) {
      this.toDefaultState();
    }
  }

  changeState() {
    if (this.config.fixMomentClasses) {
      this.element.classList.add(...this.config.fixMomentClasses);
    }

    this.element.classList.remove('navbar-untransitioned');

    if (this.animationTimeoutId) {
      clearTimeout(this.animationTimeoutId);
    }

    this.toggleEffectClass('remove');
    this.defaultState = !this.defaultState;
  }

  toDefaultState() {
    let self = this;

    if (this.config.fixMomentClasses) {
      this.element.classList.remove(...this.config.fixMomentClasses);
    }

    this.animationTimeoutId = setTimeout(function () {
      self.element.classList.add('navbar-untransitioned');
    }, this.transitionDuration);

    this.toggleEffectClass('add');
    this.defaultState = !this.defaultState;
  }

  toggleEffectClass(action) {
    const effectClasses = {
      fade: 'navbar-faded',
      slide: 'navbar-moved-up',
      'show-hide': 'navbar-invisible',
    };

    this.element.classList[action](effectClasses[this.effect]);
  }

  _insertCap() {
    this.element.classList.add('navbar-scrolled', 'navbar-untransitioned');

    if (this.element.classList.contains('navbar-static')) {
      document.documentElement.style.paddingTop = this.element.offsetHeight;
    }

    this.toggleEffectClass('add');
    this.capInserted = true;
  }

  _removeCap() {
    let self = this;

    this.element.classList.remove('navbar-scrolled');

    if (this.element.classList.contains('navbar-static')) {
      document.documentElement.style.paddingTop = 0;
    }

    if (this.removeCapTimeOutId) {
      clearTimeout(this.removeCapTimeOutId);
    }

    this.removeCapTimeOutId = setTimeout(function () {
      self.toggleEffectClass('remove');
    }, 10);

    this.capInserted = false;
  }
}
